import { render } from "./garmentLayersStep.vue?vue&type=template&id=25353c37&ts=true"
import script from "./garmentLayersStep.vue?vue&type=script&lang=ts"
export * from "./garmentLayersStep.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__